import React from "react";
import { Link, Outlet, NavLink, useLocation } from "react-router-dom";
import "./nav.css";

export default function Nav() {
  const { pathname } = useLocation();
  const isHome = pathname === "/";

  return (
    <div className="site">
      {!isHome && (
        <header className="site-header">
          <Link to="/" className="brand" aria-label="A Quiet Boom home">
            A Quiet Boom
          </Link>

          <nav className="nav" aria-label="Primary">
            <NavLink to="/about" className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}>
              About
            </NavLink>
            <NavLink to="/listen" className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}>
              Listen
            </NavLink>
            <NavLink to="/watch" className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}>
              Watch
            </NavLink>
            <NavLink to="/shows" className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}>
              Shows
            </NavLink>
            <NavLink to="/contact" className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}>
              Contact
            </NavLink>
          </nav>
        </header>
      )}

      <main className={isHome ? "site-main site-main--home" : "site-main"}>
        <Outlet />
      </main>

      {!isHome && (
        <footer className="site-footer">
          <span>© {new Date().getFullYear()} A Quiet Boom</span>
        </footer>
      )}
    </div>
  );
}